import { render, staticRenderFns } from "./IdentifyList.vue?vue&type=template&id=4795658c&"
import script from "./IdentifyList.vue?vue&type=script&lang=js&"
export * from "./IdentifyList.vue?vue&type=script&lang=js&"
import style0 from "./IdentifyList.vue?vue&type=style&index=0&id=4795658c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports